<template>
  <v-row no-gutters>
    <v-col cols="12" :class="$vuetify.breakpoint.mdAndDown ? 'px-3' : 'px-5'">
      <v-form ref="editPersonalForm">
        <app-form-field
          :enabledLabel="true"
          v-model.trim="personalInfo.address"
          :label="$t(`field.house`)"
          :placeholder="$t(`fieldHint.fillUpHere`)"
          :rules="validator.addressRules(5, 100)"
        ></app-form-field>
        <app-form-field
          :enabledLabel="true"
          v-model.trim="personalInfo.province"
          :label="$t(`field.town`)"
          :placeholder="$t(`fieldHint.fillUpHere`)"
          :rules="validator.regionRules(3, 50)"
        ></app-form-field>
        <app-form-field
          :enabledLabel="true"
          v-model.trim="personalInfo.country"
          :label="$t(`field.thana`)"
          :placeholder="$t(`fieldHint.fillUpHere`)"
          :rules="validator.cityRules(3, 50)"
        ></app-form-field>
        <app-form-field
          :enabledLabel="true"
          v-model.trim="personalInfo.place_of_birth"
          :label="$t(`field.zila`)"
          :placeholder="$t(`fieldHint.fillUpHere`)"
          :rules="validator.cityRules(3, 50)"
        ></app-form-field>
        <app-form-field
          :enabledLabel="true"
          v-model.trim="personalInfo.postcode"
          :label="$t(`field.postalCode`)"
          :placeholder="$t(`fieldHint.fillUpHere`)"
          :rules="validator.postCodeRules(4, 9)"
        ></app-form-field>
        <v-row no-gutters class="pb-10">
          <v-col cols="12">
            <app-button class="dialog-button white--text" :action="this.submit" :title="$t(`button.submit`)"></app-button>
          </v-col>
        </v-row>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import stingFormat from 'string-format'
import { formValidator, uiHelper, errorCodeHelper, locale } from '@/util'
import { SHARED } from '@/constants/constants'
import { MEMBER_UPDATE_DETAIL } from '@/store/member.module'
export default {
  name: 'editAddress',
  mounted() {},
  props: {
    closeAction: {
      type: Function,
      required: true,
      default: () => {}
    },
    personalInfo: {
      type: Object,
      require: true,
      default: {}
    }
  },
  created() {
    this.isFullNameReadOnly = this.personalInfo.fullName ? true : false
  },
  data: () => ({
    propFullName: '',
    isFullNameEditable: false,
    dateOfBirthMaxDate: new Date(new Date().setFullYear(new Date().getFullYear() - 18)).toISOString().substr(0, 10),
    dateOfBirthMenu: false,
    language: uiHelper.getLanguage(),
    validator: formValidator,
    stingFormat: stingFormat,
    memberInfo: {},
    mobileNumberPrefixList: [
      {
        text: '+91',
        value: 'INR'
      },
      {
        text: '+880',
        value: 'BDT'
      },
      {
        text: '+977',
        value: 'NPR'
      }
    ]
  }),
  computed: {
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    },
    mobilePrefix() {
      let self = this
      let prefix = _.find(this.mobileNumberPrefixList, function(p) {
        return p.value == self.personalInfo.currency
      })
      if (prefix) return prefix.text
      else return ''
    }
  },
  watch: {
    dateOfBirthMenu(val) {
      val && setTimeout(() => (this.$refs.dateOfBirthPicker.activePicker = 'YEAR'))
    }
  },
  methods: {
    submit() {
      if (this.$refs.editPersonalForm.validate()) {
        this.confirmationDialog()
      }
    },
    updateMember() {
      let memberObj = this.personalInfo
      this.$store.dispatch(`${MEMBER_UPDATE_DETAIL}`, { memberObj })
      this.closePageDialog()
      this.closeAction()
    },
    confirmationDialog() {
      let dialog = this.initializePageDialogProperty()
      dialog.title = locale.getMessage(`label.updateMemberAddressDetail`)
      dialog.message.push(locale.getMessage(`message.confirmUpdateProfileAddress`))
      dialog.button.push({
        title: locale.getMessage(`button.submit`),
        action: () => this.updateMember()
      })
      this.openPageDialog(dialog)
    },
    initializePageDialogProperty() {
      let initPageDialog = {
        title: locale.getMessage(`label.system`),
        dialogXButton: this.closePageDialog,
        messageTitle: '',
        message: [],
        button: []
      }
      return initPageDialog
    },
    openPageDialog(dialog) {
      this.$eventHub.$emit('open-page-dialog', dialog)
    },
    closePageDialog() {
      this.$refs.editPersonalForm.reset()
      this.$eventHub.$emit('close-page-dialog', true)
    }
  }
}
</script>

<style lang="scss">
.custom-date-picker .v-date-picker-table td {
  padding: 0px;
}
</style>
